module.exports = __webpack_public_path__ + "img/HLJ11X5.png";